 import axios from "axios";

export const appHelpers = {
  getRequest: function(url, header) {
    let reqHeader = header
      ? header
      : { "Content-Type": "application/json" };
    let config = { headers: reqHeader };
    // console.log(config);
    return axios
      .get(url, config)
      .then(function(res) {
        return res;
      })
      .catch(function(err) {
        // console.log(err);
      });
  },
    postRequest: function(url, payload, header) {
        let reqHeader = header
            ? header
            : { "Content-Type": "application/json"};
        let config = { headers: reqHeader };

        return axios.post(url, payload, config);
    }
};



// WEBPACK FOOTER //
// ./src/utils/app.helpers.js